import Container from '@mui/material/Container';
import { SxProps, Theme } from '@mui/material';

interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  sx?: SxProps<Theme>;
}

const PageContainer = ({ children, maxWidth = false, sx }: PageContainerProps) => {
  return (
    <Container
      maxWidth={maxWidth}
      disableGutters
      className="page-enter"
      sx={{
        width: { xs: 'calc(100% - 28px)', md: 'min(95%, 1200px)' },
        marginTop: '88px',
        marginBottom: '60px',
        position: 'relative',
        zIndex: 1,
        ...sx as any,
      }}
    >
      {children}
    </Container>
  );
};

export default PageContainer;
